export default "__VITE_ASSET__cNSPdAzg__"